import { render } from "./xfsMain.vue?vue&type=template&id=998a3f84&scoped=true"
import script from "./xfsMain.vue?vue&type=script&lang=js"
export * from "./xfsMain.vue?vue&type=script&lang=js"

import "./xfsMain.vue?vue&type=style&index=0&id=998a3f84&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/edu-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-998a3f84"]])

export default __exports__